import React from "react";
import Typist from "react-text-typist";

function Intro({ search, getSearch, isLoading, isFetch, handleFetch }) {
  const handleSearch = (value) => {
    const filteredValue = value;
    getSearch(filteredValue);
  };

  //* * * handleFetch
  const handleFetchFunc = (e) => {
    e.preventDefault();
    handleFetch(true);
  };
  return (
    <div className="intro_container">
      <div className="container">
        <div className="intro_inner gradient-1">
          <div className="flex flex-col justify-center w-3/4">
            <h1 className="intro_title text-center">
              A Search Engine for the social web.
            </h1>
            <div className="intro_tagline">
              <Typist
                typingSpeed={120}
                deletingSpeed={50}
                pauseTime={1500}
                cursorSmooth={true}
                sentences={[
                  "Search billions of social media posts in seconds.",
                  "Search Your Most Relevant Hashtags Now.",
                  "Search All Social Media Platforms with One Simple Tool.",
                ]}
                loop={true}
              />
            </div>
            <div className="search_container">
              <form onSubmit={handleFetchFunc}>
                <input
                  type="text"
                  placeholder="Search..."
                  className="search_input"
                  value={search}
                  onChange={(e) => handleSearch(e.target.value)}
                />
                {isLoading ? (
                  <button className="search_button" type="button">
                    Loading...
                  </button>
                ) : (
                  <button className="search_button" type="submit">
                    Search
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
